import { createWebHistory, createRouter } from 'vue-router';
import store from '../store/store.js'; // store를 import
// import store from '../store/store.js'
import { useStore } from 'vuex';
import axios from 'axios';
import { checkPermission, componentPermission } from '@/js/permission';
import { watch } from 'vue';
import commonPaths from '@/js/commonPaths.js';
import  i18n from "@/js/i18n";

function checkUserPermission(to, from, next) {
    const store = useStore();
    const token = store.getters['loginModule/getAccessToken'];

    if (!token) {
        next('/login');
        return;
    }

    const path = to.path.substr(1).split('/')[0];
    const groupedPath = getGroupedPath(path);
    store.dispatch('setActiveMenu', groupedPath);

    if (to.path === '/') {
        next('/dash');
        return;
    }

	// 권한에 따른 라우터 이동 제한
    const permissions = [
		{ group: '대동', role: 'ADMIN', paths: [] },
		{ group: '대동', role: 'STAFF', paths: commonPaths.readyOnly },
		{ group: '생산본부', role: 'ADMIN', paths: commonPaths.production },
		{ group: '생산본부', role: 'STAFF', paths: commonPaths.productionStaff },
		{ group: 'CustomerBiz부문', role: 'ADMIN', paths: commonPaths.biz },
		{ group: 'CustomerBiz부문', role: 'STAFF', paths: commonPaths.bizStaff },
		{ group: '국내영업본부', role: 'ADMIN', paths: commonPaths.sales },
		{ group: '국내영업본부', role: 'STAFF', paths: commonPaths.salesStaff },
		{ group: '사업팀', role: 'ADMIN', paths: commonPaths.business },
		{ group: '사업팀', role: 'STAFF', paths: commonPaths.businessStaff },
		{ group: '지역', role: 'ADMIN', paths: commonPaths.region },
		{ group: '지역', role: 'STAFF', paths: commonPaths.regionStaff },
		{ group: '대리점', role: 'ADMIN', paths: commonPaths.dealership },
		{ group: '대리점', role: 'STAFF', paths: commonPaths.dealershipStaff },
		{ group: '서비스사업팀', role: 'ADMIN', paths: [] },
		{ group: '서비스사업팀', role: 'STAFF', paths: commonPaths.readyOnly },
		{ group: '본사', role: 'ADMIN', paths: [] },
		{ group: '본사', role: 'STAFF', paths: [] },
		{ group: 'Biz본부', role: 'ADMIN', paths: commonPaths.biz },
		{ group: 'Biz본부', role: 'STAFF', paths: commonPaths.biz },
	];

    const userPermission = permissions.find(perm => checkPermission(perm.group, perm.role));

    if (userPermission) {
        if (userPermission.paths.includes(to.name)) {
            next('/dash');
            return;
        }
    }
    next();
}

function getUserIdFromToken(token) {
    const base64Url = token.split('.')[1];
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	const tokenPayload = JSON.parse(decodeURIComponent(escape(window.atob(base64))));
    return tokenPayload.userId;
}

function getGroupedPath(path) {
    const pathGroups = {
        'production': 'vehicle', 'productionDetail': 'vehicle', 'productionModi': 'vehicle',
        'sale': 'vehicle', 'saleDetail': 'vehicle', 'status': 'vehicle', 
        'statusDetail': 'vehicle', 'statusModi': 'vehicle', 'model': 'vehicle', 
        'modelRegi': 'vehicle', 'modelDetail': 'vehicle', 'modelModi': 'vehicle',
        'device': 'vehicle', 'deviceDetail': 'vehicle', 'deviceModi': 'vehicle',

        'expendable': 'maintenance', 'expendableDetail': 'maintenance', 'breakdown': 'maintenance',
        'sos': 'maintenance', 'ownerTransfer': 'maintenance',

        'organization': 'user', 'customer': 'user', 'customerDetail': 'user',
        'customerRegi': 'user', 'customerVehicleRegi': 'user', 'customerVehicleModi': 'user',

        'driveData': 'statistics', 'driveDataDetail': 'statistics', 'operationData': 'statistics', 
        'operationDataModelDetail': 'statistics', 'operationDataCusDetail': 'statistics',

        'remote': 'remoteService', 'remoteDetail': 'remoteService', 'remoteHistory': 'remoteService', 
        'afterService': 'remoteService', 'afterServiceDetail': 'remoteService', 'afterServiceHistory': 'remoteService',
        'reProgram': 'remoteService', 'reProgramDetail': 'remoteService', 'reProgramHistory': 'remoteService',

        'notice': 'customerService', 'faq': 'customerService', 'post': 'customerService',
        'noticeDetail': 'customerService', 'faqDetail': 'customerService', 'postDetail': 'customerService',
        'noticeRegi': 'customerService', 'faqRegi': 'customerService', 'postRegi': 'customerService',

        'category': 'ecommerce', 'categoryModi': 'ecommerce', 'shopBanner': 'ecommerce', 
        'shopBannerModi': 'ecommerce', 'partDisplay': 'ecommerce', 'partDisplayModi': 'ecommerce',
		'gptBanner': 'gptService', 'gptBannerRegi': 'gptService', 'gptBannerModi': 'gptService', 'gptChatData': 'gptService',
		'administrator': 'administrator','memberHistory': 'administrator',

        'dash': 'home'
    };

    return pathGroups[path] || path;
}

function checkDevicePermission(to, from, next) {
	let token = store.getters['loginModule/getAccessToken'];
	if (token === null || token === '') {
	  	next('/login')
	} else {
		const store = useStore();
		store.dispatch('setActiveMenu', 'remote');

		const deviceId = to.params.number;
	
		axios.get(`${process.env.VUE_APP_API_URL_REMOTE}/api/remote/device/detail/${deviceId}`).then((response) => {
			if (response.data.isConnect === true) {
				next();
			}
		}).catch((error) => {
			console.error(error);
		});
	}
}
const routes = [
	{ path: '/login', name: 'login', component: () => import('@/views/login/Login.vue') }, //로그인
    { path:'/authenticateSms', name: 'authenticateSms', component: () => import('@/views/login/AuthenticateSms.vue') }, //sms인증
	{ path: '/findId', name: 'findId', component: () => import('@/views/login/FindId.vue') }, //아이디 찾기
	{ path:'/findPw', name: 'findPw', component: () => import('@/views/login/FindPw.vue') }, //비밀번호 찾기
	{ path:'/join', name: 'joinMember', component: () => import('@/views/login/JoinMember.vue') }, //회원가입
	{ path:'/changePwd', name: 'changePwd', component: () => import('@/views/login/ChangePwd.vue') }, //비밀번호 변경
	{ path:'/changeExpiredPwd', name: 'changeExpiredPwd', component: () => import('@/views/login/ChangeExpiredPwd.vue') }, //유효기한 만료된 비밀번호 변경
	{ path: '/reportApp', name: 'reportAppMng', component: () => import('@/views/app/ReportAppMng.vue') }, //앱 고객 리포트 목록
	// { path: '/reportDetailApp/:number', name: 'reportDetailAppMng', component: () => import('@/views/app/ReportDetailAppMng.vue'), props: true }, //앱 고객 리포트 상세
	{ path: '/reportDetailApp/:vinId/:accessToken', name: 'reportDetailAppMng', component: () => import('@/views/app/ReportDetailAppMng.vue'), props: true }, //앱 고객 리포트 상세
	{ path: '/noticeApp', name: 'noticeAppMng', component: () => import('@/views/app/NoticeAppMng.vue') }, //앱 공지사항 목록
	{ path: '/noticeDetailApp/:number', name: 'noticeDetailAppMng', component: () => import('@/views/app/NoticeDetailAppMng.vue'), props: true }, //앱 공지사항 상세
	{ path: '/faqApp', name: 'faqAppMng', component: () => import('@/views/app/FaqAppMng.vue') }, //앱 FAQ 목록
	{ path: '/faqDetailApp/:number', name: 'faqDetailAppMng', component: () => import('@/views/app/FaqDetailAppMng.vue'), props: true }, //앱 FAQ 상세
	{ path: '/postApp', name: 'postAppMng', component: () => import('@/views/app/PostAppMng.vue') }, //앱 게시판 목록
	{ path: '/postDetailApp/:number', name: 'postDetailAppMng', component: () => import('@/views/app/PostDetailAppMng.vue'), props: true }, //앱 게시판 상세
	{ path: '/RdiDownload/:vehicleTakeoverId', name: 'rdiDownload', component: () => import('@/views/vehicleMng/RdiDownload.vue'), props: true }, //PDF 다운로드 링크
	{
		path: '/',
		redirect: '/dash',
		name: 'home',
		component: () => import('@/views/Home.vue'),
		beforeEnter: (to, from, next) => {
			let token = store.getters['loginModule/getAccessToken'];
			if (token === null || token === '') {
				next('/login')
			} else if (to.path === '/api/swagger') {
				next('/api/swagger')
			} else {
				next()
			}
		},
		children: [
			//대쉬보드
			{ path: '/dash', name: 'dashBoard', component: () => import('@/views/home/DashBoard.vue'), beforeEnter: checkUserPermission },
			//차량관리-생산관리
			{ path: '/production', name: 'productionMng', component: () => import('@/views/vehicleMng/ProductionMng.vue'), beforeEnter: checkUserPermission },
			//차량관리-생산관리 상세
			{ path: '/productionDetail/:number', name: 'productionMngDetail', component: () => import('@/views/vehicleMng/ProductionMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-생산관리 수정
			{ path: '/productionModi/:number', name: 'productionMngModi', component: () => import('@/views/vehicleMng/ProductionMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-출하/판매정보조회
			{ path: '/sale', name: 'infoCheck', component: () => import('@/views/vehicleMng/InfoCheck.vue'), beforeEnter: checkUserPermission },
			//차량관리-출하/판매정보조회 상세
			{ path: '/saleDetail/:number', name: 'infoCheckDetail', component: () => import('@/views/vehicleMng/InfoCheckDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-차량현황관리
			{ path: '/status', name: 'vehicleSttsMng', component: () => import('@/views/vehicleMng/VehicleSttsMng.vue'), beforeEnter: checkUserPermission },
			//차량관리-차량현황관리 상세
			{ path: '/statusDetail/:number', name: 'vehicleSttsMngDetail', component: () => import('@/views/vehicleMng/VehicleSttsMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-차량현황관리 수정
			{ path: '/statusModi/:number', name: 'vehicleSttsMngModi', component: () => import('@/views/vehicleMng/VehicleSttsMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-모델관리
			{ path: '/model', name: 'modelMng', component: () => import('@/views/vehicleMng/ModelMng.vue'), beforeEnter: checkUserPermission },
			//차량관리-모델관리 등록
			{ path: '/modelRegi/:number', name: 'modelMngRegi', component: () => import('@/views/vehicleMng/ModelMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-모델관리 상세
			{ path: '/modelDetail/:number', name: 'modelMngDetail', component: () => import('@/views/vehicleMng/ModelMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-모델관리 수정
			{ path: '/modelModi/:number', name: 'modelMngModi', component: () => import('@/views/vehicleMng/ModelMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-단말기관리
			{ path: '/device', name: 'deviceMng', component: () => import('@/views/vehicleMng/DeviceMng.vue'), beforeEnter: checkUserPermission },
			//차량관리-단말기관리 상세
			{ path: '/deviceDetail/:number', name: 'deviceMngDetail', component: () => import('@/views/vehicleMng/DeviceMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량관리-단말기관리 수정
			{ path: '/deviceModi/:number', name: 'deviceMngModi',component: () => import('@/views/vehicleMng/DeviceMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//차량유지관리-소모품관리
			{ path: '/expendable', name: 'consMng', component: () => import('@/views/vehicleMnt/ConsMng.vue'), beforeEnter: checkUserPermission },
			//차량유지관리-소모품관리 상세
			{ path: '/expendableDetail/:number', name: 'consMngDetail', component: () => import('@/views/vehicleMnt/ConsMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//차량유지관리-고장신고
			{ path: '/breakdown', name: 'report', component: () => import('@/views/vehicleMnt/Report.vue'), beforeEnter: checkUserPermission },
			//차량유지관리-SOS호출
			{ path: '/sos', name: 'sosCall', component: () => import('@/views/vehicleMnt/SosCall.vue'), beforeEnter: checkUserPermission },
			//차량유지관리-소유권이전관리
			{ path: '/ownerTransfer', name: 'osTransMng', component: () => import('@/views/vehicleMnt/OsTransMng.vue'), beforeEnter: checkUserPermission },
			//사용자관리-고객관리(App회원)
			{ path: '/customer', name: 'userAppMng', component: () => import('@/views/userMng/UserAppMng.vue'), beforeEnter: checkUserPermission },
			//사용자관리-고객관리(App회원) 등록
			{ path: '/customerRegi/:number', name: 'userRegi', component: () => import('@/views/userMng/UserRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//사용자관리-고객관리(App회원) 상세
			{ path: '/customerDetail/:number', name: 'userAppMngDetail', component: () => import('@/views/userMng/UserAppDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//사용자관리-고객관리(App회원) 상세 차량 등록
			{ path: '/customerVehicleRegi/:number', name: 'userVehicleRegi', component: () => import('@/views/userMng/UserVehicleRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//사용자관리-고객관리(App회원) 상세 차량 수정
			{ path: '/customerVehicleModi/:number', name: 'userVehicleModi', component: () => import('@/views/userMng/UserVehicleModi.vue'), props: true, beforeEnter: checkUserPermission },
			//사용자관리-조직관리
			{ path: '/organization', name: 'orgMng', component: () => import('@/views/userMng/OrgMng.vue'), props: true, beforeEnter: checkUserPermission },
			//통계조회-차량운행데이터
			{ path: '/driveData', name: 'driveData', component: () => import('@/views/statCheck/DriveData.vue'), props: true, beforeEnter: checkUserPermission },
			//통계조회-차량운행데이터 상세
			{ path: '/driveDataDetail/:number', name: 'driveDataDetail', component: () => import('@/views/statCheck/DriveDataDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//통계조회-차량운영데이터
			{ path: '/operationData', name: 'operationData', component: () => import('@/views/statCheck/OperationData.vue'), props: true, beforeEnter: checkUserPermission },
			//통계조회-차량운영데이터-모델 상세
			{ path: '/operationDataModelDetail/:number', name: 'operationDataModelDetail', component: () => import('@/views/statCheck/OperationDataModelDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//통계조회-차량운영데이터-고객차량 상세
			{ path: '/operationDataCusDetail/:number', name: 'operationDataCusDetail', component: () => import('@/views/statCheck/OperationDataCusDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-공지사항 관리
			{ path: '/notice', name: 'noticeMng', component: () => import('@/views/customerService/NoticeMng.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-공지사항 관리 등록
			{ path: '/noticeRegi/:number', name: 'noticeMngRegi', component: () => import('@/views/customerService/NoticeMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-공지사항 관리 상세
			{ path: '/noticeDetail/:number', name: 'noticeMngDetail', component: () => import('@/views/customerService/NoticeMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-FAQ 관리
			{ path: '/faq', name: 'faqMng', component: () => import('@/views/customerService/FaqMng.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-FAQ 관리 등록
			{ path: '/faqRegi/:number', name: 'faqMngRegi', component: () => import('@/views/customerService/FaqMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-FAQ 관리 상세
			{ path: '/faqDetail/:number', name: 'faqMngDetail', component: () => import('@/views/customerService/FaqMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-게시판 관리
			{ path: '/post', name: 'postMng', component: () => import('@/views/customerService/PostMng.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-게시판 관리 등록
			{ path: '/postRegi/:number', name: 'postMngRegi', component: () => import('@/views/customerService/PostMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//고객센터-게시판 관리 상세
			{ path: '/postDetail/:number', name: 'postMngDetail', component: () => import('@/views/customerService/PostMngDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-원격진단
			{ path: '/remote', name: 'remote', component: () => import('@/views/remote/Remote.vue'), beforeEnter: checkUserPermission },
			//원격진단-원격진단 상세
			{ path: '/remoteDetail/:number', name: 'remoteDetail', component: () => import('@/views/remote/RemoteDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-원격진단 이력
			{ path: '/remoteHistory/:number', name: 'remoteHistory', component: () => import('@/views/remote/RemoteHistory.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-애프터서비스
			{ path: '/afterService', name: 'afterService', component: () => import('@/views/remote/AfterService.vue'), beforeEnter: checkUserPermission },
			//원격진단-애프터서비스 상세
			{ path: '/afterServiceDetail/:number', name: 'afterServiceDetail', component: () => import('@/views/remote/AfterServiceDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-애프터서비스 이력
			{ path: '/afterServiceHistory/:number', name: 'afterServiceHistory', component: () => import('@/views/remote/AfterServiceHistory.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-리프로그램
			{ path: '/reProgram', name: 'reProgram', component: () => import('@/views/remote/ReProgram.vue'), beforeEnter: checkUserPermission },
			//원격진단-리프로그램 상세
			{ path: '/reProgramDetail/:number', name: 'reProgramDetail', component: () => import('@/views/remote/ReProgramDetail.vue'), props: true, beforeEnter: checkUserPermission },
			//원격진단-리프로그램 이력
			{ path: '/reProgramHistory/:number', name: 'reProgramHistory', component: () => import('@/views/remote/ReProgramHistory.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-카테고리 관리
			{ path: '/category', name: 'cateMng', component: () => import('@/views/partsConsSales/CateMng.vue'), beforeEnter: checkUserPermission },
			//부품/소모품 판매-카테고리 관리 등록
			{ path: '/category/:number', name: 'cateMngRegi', component: () => import('@/views/partsConsSales/CateMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-카테고리 관리 수정
			{ path: '/categoryModi/:number', name: 'cateMngModi', component: () => import('@/views/partsConsSales/CateMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-대동 Shop 배너 관리
			{ path: '/shopBanner', name: 'banMng', component: () => import('@/views/partsConsSales/BanMng.vue'), beforeEnter: checkUserPermission },
			//부품/소모품 판매-대동 Shop 배너 관리 등록
			{ path: '/shopBanner/:number', name: 'banMngRegi', component: () => import('@/views/partsConsSales/BanMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-대동 Shop 배너 관리 수정
			{ path: '/shopBannerModi/:number', name: 'banMngModi', component: () => import('@/views/partsConsSales/BanMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-부품/소모품 진열
			{ path: '/partDisplay', name: 'partsCons', component: () => import('@/views/partsConsSales/PartsCons.vue'), beforeEnter: checkUserPermission },
			//부품/소모품 판매-부품/소모품 진열 등록
			{ path: '/partDisplay/:number', name: 'partsConsRegi', component: () => import('@/views/partsConsSales/PartsConsRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//부품/소모품 판매-부품/소모품 진열 수정
			{ path: '/partDisplayModi/:number', name: 'partsConsModi', component: () => import('@/views/partsConsSales/PartsConsModi.vue'), props: true, beforeEnter: checkUserPermission },
			//GPT 관리-배너 관리
			{ path: '/gptBanner', name: 'gptBanMng', component: () => import('@/views/gptMng/GptBanMng.vue'), props: true, beforeEnter: checkUserPermission },
			//GPT 관리-배너 등록
			{ path: '/gptBannerRegi', name: 'gptBanMngRegi', component: () => import('@/views/gptMng/GptBanMngRegi.vue'), props: true, beforeEnter: checkUserPermission },
			//GPT 관리-배너 수정
			{ path: '/gptBannerModi/:number', name: 'gptBanMngModi', component: () => import('@/views/gptMng/GptBanMngModi.vue'), props: true, beforeEnter: checkUserPermission },
			//GPT 관리-GPT Chat 데이터
			{ path: '/gptChatData', name: 'gptChatData', component: () => import('@/views/gptMng/GptChatData.vue'), props: true, beforeEnter: checkUserPermission },
			
			//관리자 관리-관리자 이력 조회
			{ path: '/memberHistory', name: 'memberHistory', component: () => import('@/views/memberHistory/MemberHistory.vue'), props: true, beforeEnter: checkUserPermission },
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.onError((error) => {
	console.error('라우터 오류:', error);
	window.location.reload();
});

router.beforeEach((to, from, next) => {
	const token = store.state.loginModule.accessToken;
	const permission = store.getters.getPermission;
	if (token && !permission) {
		componentPermission();
	};
	if (to.path == '/login' && from.path == '/join') {
		const loginData = {
			accessToken: null,
			accessTokenExpiredDate: null,
			refreshToken: null,
			refreshTokenExpiredDate: null
		};
		store.dispatch('loginModule/saveLoginData',loginData);
		store.dispatch('clearVehicleData');
		store.dispatch('IotResult/clearResult');
		store.dispatch('clearDataItems');
		store.dispatch('setGroupId', null);
		store.dispatch('setLoginGroup', null);
		store.commit('setCurrentPage', 1);
		store.dispatch('setVinId', '');
		store.dispatch('setActiveMenu', null);
		store.dispatch('resetAllParams');
		store.dispatch('setIotState',null);
		//localStorage.setItem('autoLogin', false); //autoLogin 주석처리
		store.dispatch('setAxiosLoading', false);
		store.dispatch('regiSave/clearRegiTemp');
		store.dispatch('setAppToken', null);
		store.dispatch('clearPermission');
	}
	next();
});

//// 차량리포트쪽만 브라우저 언어셋(Accept-Language) 값데 따라 한글/영문 적용하기 위해 추가 ///////////////////////////////
const getLanguage = () => {    
    let lang = navigator.language || navigator.userLanguage || navigator.systemLanguage || 'en';
    if (!lang.toLowerCase().includes('en') && !lang.toLowerCase().includes('ko')) {
        lang = 'en';
    }

    let langArr = lang.split("-");
    if (langArr.length > 1) {
        lang = langArr[0];
    }

    return lang;
};

/*
router.afterEach((to, from) => {
	const toPath = to.path;
	const toName = to.name;
	const fromPath = from.path;
	const fromName = from.name;
	if (toPath.startsWith('/reportDetailApp/') || toName === 'reportDetailAppMng') {
		console.log(i18n.global.locale);
		i18n.global.locale.value = getLanguage();
	} else if (fromPath.startsWith('/reportDetailApp/') || fromPath === 'reportDetailAppMng') {
		if (getLanguage() !== 'en') {
			i18n.global.locale.value = 'en';
		}
	} else {		
	}
});
*/
//// 차량리포트쪽만 브라우저 언어셋(Accept-Language) 값데 따라 한글/영문 적용하기 위해 추가 ///////////////////////////////
export default router;